import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AssessmentRowComponent } from '../assessment-row/assessment-row.component';
import { EmrCheckboxGroupComponent } from "../../../../shared/emr-checkbox-group/emr-checkbox-group.component";
import { EmrInputComponent } from "../../../../shared/emr-input/emr-input.component";
import { WnlGroupDirective } from '../wnl/wnl-group.directive';
import { WnlControlDirective } from '../wnl/wnl-control.directive';

import { Patient } from 'src/app/calvin-emr-shared/models/patient.model';
import { EmrCheckboxComponent } from "../../../../shared/emr-checkbox/emr-checkbox.component";

import { FormOption } from 'src/app/shared/models/form-option.model';
import { GenitourinaryFormGroup } from 'src/app/calvin-emr-shared/models/assessments/genitourinary.model';

@Component({
  selector: 'app-genitourinary-form',
  templateUrl: './genitourinary-form.component.html',
  styleUrls: ['./genitourinary-form.component.scss', '../assessments-tab.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    AssessmentRowComponent,
    EmrCheckboxGroupComponent,
    EmrInputComponent,
    EmrCheckboxComponent,
    WnlGroupDirective,
    WnlControlDirective,
  ],
})
export class GenitourinaryFormComponent {

  formGroup = input.required<GenitourinaryFormGroup>();
  patient = input.required<Patient>();



  urineColorOptions = [
    new FormOption('Yellow'),
    new FormOption('Dark Yellow'),
    new FormOption('Blood Tinged'),
    new FormOption('WNL'),
  ];

  urineCharacteristicsOptions = [
    new FormOption('Cloudy'),
    new FormOption('Sediment'),
    new FormOption('Odor'),
  ];

  urinaryPatternOptions = [
    new FormOption('Frequency', 'frequency'),
    new FormOption('Nocturia', 'nocturia'),
    new FormOption('Dysuria', 'dysuria'),
    new FormOption('Incontinence', 'incontinence'),
    new FormOption('Retention', 'retention'),
  ];


  urinaryPatternOptionsPediatric = [
    new FormOption('Frequency', 'frequency'),
    new FormOption('Nocturia', 'nocturia'),
    new FormOption('Dysuria', 'dysuria'),
    new FormOption('Incontinence', 'incontinence'),
    new FormOption('Retention', 'retention'),
    new FormOption('Inappropriate for Developmental Age', 'inappropriateForDevelopmentalAge'),
  ];


  reset() {
    this.formGroup().enable({ emitEvent: false });
  }


}
